// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".search-button[data-v-5c5758f0]{height:3rem!important}.filter-link.nuxt-link-active[data-v-5c5758f0]{--text-opacity:1;color:#9dba48;color:rgba(157,186,72,var(--text-opacity))}.filter-link.nuxt-link-active[data-v-5c5758f0]:hover{--text-opacity:1;color:#fff;color:rgba(255,255,255,var(--text-opacity))}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
